import { Component, ViewChild } from '@angular/core';
import { MerchantTableViewComponent } from '../../merchant-table-view/merchant-table-view.component';
import { Merchant } from '../../../../models/merchant/merchant';
import { StorageService } from '../../../../core/storage/storageService';
import { TableView } from '../../../../components/ui/filterable-table/tableView';
import { AccountService } from '../../../../models/account/accountService';
import { Options } from '../../../../components/ui/filterable-table/options';
import { AccessManager } from '../../../ui/access-manager/access-manager';

@Component({
  selector: 'app-merchant-business-view',
  templateUrl: './merchant-business-view.component.html',
  standalone: false,
})
export class MerchantBusinessViewComponent {
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;

  toggleTableOn: boolean = false;
  namespace: string = AccessManager.AUTH_SELECT_MERCHANT_INFO;

  selectedMerchant: Merchant | undefined;

  merchantTableOptions: Options = new Options({
    selectAction: 'expand',
  });

  merchantTableView: any;

  constructor(
    private storage: StorageService,
  ) {
    this.merchantTableView = new TableView(MerchantTableViewComponent);
  }

  ngOnInit() {
    this.selectedMerchant = this.storage.getSelectedLocation() as Merchant;

    if (!this.selectedMerchant) {
      throw 'no selected merchant';
    }
  }
}
